import Image from 'next/image';
import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { brandColor, getEditorColor } from '../../util/ColorUtil';
import { isLinkAbsolute } from '../../util/DataUtil';

const LargeCtaButton = ({ data, borderColor }) => {
  const router = useRouter();
  const file = data?.field_marketo_file_url[0]?.value;
  const pageAlias = data?.field_large_cta_page_link[0]?.['url-alias'];
  const mustBorder = brandColor(data?.field_icon_color[0]?.value);
  const border = mustBorder ? mustBorder : borderColor;
  const [href, setHref] = useState('');
  const [target, setTarget] = useState('_self');

  useEffect(() => {
    setHrefValue();
    setTargetValue();
  }, []);

  const setHrefValue = () => {
    if (typeof window !== 'undefined') {
      const href = pageAlias ? pageAlias : file;
      if (href) {
        setHref(href);
      }
    }
  };

  const setTargetValue = () => {
    if (typeof window !== 'undefined') {
      const target = pageAlias
        ? isLinkAbsolute(pageAlias)
          ? '_blank'
          : null
        : file
          ? '_blank'
          : null;
      if (target) {
        setTarget(target);
      }
    }
  };

  return (
    <a
      className={'large-cta-button'}
      style={{ borderColor: border }}
      href={href}
      target={target}
    >
      <span className={'large-text'}>
        {data?.field_large_button_text[0]?.value}
      </span>
      <div
        className={
          'download-container ' +
          (data?.field_large_cta_button_type[0]?.value === '0' ? 'hover' : '')
        }
      >
        <span className={'text'}>
          {data?.field_large_cta_button_type[0]?.value === '3' && (
            <img src={'/images/cta-download.png'} alt={'download'} />
          )}
          <span className={'download-text hover ' + getEditorColor(border)}>
            {data?.field_large_button_download_text[0]?.value}
            {data?.field_large_cta_button_type[0]?.value === '0' && (
              <img
                width={'auto'}
                height={'auto'}
                className={'icons-color ' + getEditorColor(border)}
                src={'/images/arrow-right-white.svg'}
                alt={'scroll-arrow'}
              />
            )}
          </span>
        </span>
      </div>
      <Image
        priority
        layout="fill"
        alt="featured"
        src={
          data?.field_large_button_background_im[0]
            ? data?.field_large_button_background_im[0]
            : ''
        }
      />
    </a>
  );
};

export default LargeCtaButton;
